
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes from 'prop-types';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import axios from 'axios'
import { genURL, gengetURLTEST } from '../../../_getjson';
import isArrayInArray2D from '../../../CustomFunction/Arraymanage/isArrayInArray2D'
import Grid from '@mui/material/Grid';
import Button from '@material-ui/core/Button';
export default function Saleardeposituse(props) {
    const { parm } = props
    const [listitem, setListitem] = useState([])
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);
    var rowStrAll = []
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = async () => {
        var url = "CSARDEPOSIT/CODE?ARCODE=" + parm.ARCode + "&DOCNO=" + (parm.docno ? parm.docno : "") + "&TAXTYPE=" + parm.taxtype
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then((res) => {
            if (res.data.length > 0) {
                setListitem(res.data)
            }
        })
    }
    const selectRowProp = {
        mode: 'checkbox',
        onSelect: onRowSelect,
        onSelectAll: onSelectAll
    };
    async function onRowSelect(row, isSelected, e) {
        if (isSelected) {
            await rowStrAll.push(row)
        } else if (!isSelected) {
            let rowStrremove = [];
            rowStrremove.push(row);
            rowStrAll = await isArrayInArray2D(rowStrAll, rowStrremove, "REFDOCNO")
        }
    }
    async function onSelectAll(isSelected, rows) {
        if (isSelected) {
            for (let index = 0; index < rows.length; index++) {
                rowStrAll.push(rows[index])
            }
            console.log("rowStradd", rowStrAll);
        } else {
            rowStrAll = []
        }
    }

    const sendData = (row) => {
        //เช็ค push ซ้ำ 222
        if (row) {
            for (let index = 0; index <= rowStrAll.length; index++) {
                if (rowStrAll.length === 0) {
                    rowStrAll.push(row)
                } else if (rowStrAll.length < 0) {
                    if (row.DEPOSITNO !== rowStrAll[index].DEPOSITNO) {
                        rowStrAll.push(row)
                    }
                }
            }
        }
        let resdatas = []
        resdatas.push(false)
        resdatas.push("SelARDepositUse") //ส่งกลับเพื่อเป็นเงือนไขที่มา
        resdatas.push(rowStrAll)
        props.resdata(resdatas)
    }
    const indexN = (cell, row, enumObject, index) => {
        return (<div>{index + 1}</div>)
    }
    return (
        <div className="panel-body DivTable">
            <br></br>
            <button onClick={() => sendData("")}>ตกลง</button>
            <BootstrapTable
                data={listitem}
                options={{
                    onRowDoubleClick: sendData,
                    noDataText: "ไม่พบข้อมูล"
                }}
                selectRow={selectRowProp}
                height='650'
            >
                <TableHeaderColumn dataAlign="center" width="30" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='DEPOSITNO' dataAlign="center" editable={false} isKey> เลขที่ใบรับ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="90" dataField='DOCDATE' editable={false}> วันที่รับ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='REMARK' dataAlign="left" editable={false}> หมายเหตุ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="90" dataField='DEBTAMOUNT' dataAlign="left" editable={false}> จำนวนเงินทั้งสิ้น </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="90" dataField='DEBTBALANCE' dataAlign="left" editable={false}> ยอดเงินคงเหลือ </TableHeaderColumn>
            </BootstrapTable>
            <br></br>
            <Grid container spacing={3} direction="row">
                <Grid item xs={4}>
                    <Button style={{ height: '70%' }} onClick={() => sendData("")} variant="contained">ตกลง</Button>
                </Grid>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={4}>
                </Grid>
            </Grid>
            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setopensnackbar(false) }}
                close />
        </div>)
}
Saleardeposituse.prototype = {
    parm: PropTypes.array,
}
